import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Request,
    Response,
    ResponseCode
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

export class SetSupplierPrimaryContactResponse extends Response {
    constructor(obj?: { code?: ResponseCode }) {
        super(obj);
    }
}

export class SetSupplierPrimaryContactRequest extends Request {
    supplierKey: string;
    refCompanyKey: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    constructor(obj?: {
        supplierKey: string;
        refCompanyKey: string;
        firstName: string;
        lastName: string;
        emailAddress: string;
    }) {
        super();
        if (obj != null) {
            this.supplierKey =
                typeof obj.supplierKey === 'undefined' ? this.supplierKey : obj.supplierKey;
            this.refCompanyKey =
                typeof obj.refCompanyKey === 'undefined' ? this.refCompanyKey : obj.refCompanyKey;
            this.firstName = typeof obj.firstName === 'undefined' ? this.firstName : obj.firstName;
            this.lastName = typeof obj.lastName === 'undefined' ? this.lastName : obj.lastName;
            this.emailAddress =
                typeof obj.emailAddress === 'undefined' ? this.emailAddress : obj.emailAddress;
        }
    }
}

@Injectable({ providedIn: 'root' })
export class SetSupplierPrimaryContactService extends ApiService<
    SetSupplierPrimaryContactRequest,
    SetSupplierPrimaryContactResponse
> {
    public requestType = SetSupplierPrimaryContactRequest;
    public responseType = SetSupplierPrimaryContactResponse;
    public endpointName = 'supplier/SetPrimaryContact';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
